var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import styled, { css } from 'styled-components';
import { SABox } from '../box';
import { SAUX360Theme } from '../theme';
var StyledSeparator = styled(SABox)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  ", "\n"], ["\n  ",
    "\n"])), function (_a) {
    var variant = _a.variant, theme = _a.theme;
    var _b = theme.separator[variant], thickness = _b.thickness, color = _b.color;
    return css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n      &.horizontal {\n        border-bottom: ", " solid ", ";\n      }\n      &.vertical {\n        border-right: ", " solid ", ";\n      }\n    "], ["\n      &.horizontal {\n        border-bottom: ", " solid ", ";\n      }\n      &.vertical {\n        border-right: ", " solid ", ";\n      }\n    "])), thickness, color, thickness, color);
});
export function SASeparator(_a) {
    var className = _a.className, horizontal = _a.horizontal, vertical = _a.vertical, display = _a.display, variant = _a.variant, theme = _a.theme, rest = __rest(_a, ["className", "horizontal", "vertical", "display", "variant", "theme"]);
    return (React.createElement(StyledSeparator, __assign({ className: "separator " + (className || '') + (horizontal ? 'horizontal' : '') + (vertical ? 'vertical' : ''), display: display, variant: variant, theme: theme }, rest)));
}
SASeparator.defaultProps = {
    horizontal: false,
    vertical: false,
    className: undefined,
    display: undefined,
    variant: 'line',
    theme: SAUX360Theme,
};
var templateObject_1, templateObject_2;
//# sourceMappingURL=separator.component.js.map